import OddsFormatter from "app/components/OddsFormatter/OddsFormatter";
import cx from "classnames";
import React from "react";

type Props = {
  onClickPrice: (...args: Array<any>) => any;
  odds: number;
  oddsType: any;
  size?: string;
};

const AsianOddsPriceContainer: React.FC<Props> = ({
  onClickPrice,
  odds,
  oddsType,
  size,
}) => {
  return (
    <div className="asian-odds__odds__price-container">
      <div
        className={cx("asian-odds__odds__price", {
          "asian-odds__odds__price--small": size && size === "small",
        })}
        onClick={onClickPrice}
      >
        {odds && (
          <OddsFormatter
            odds={odds}
            oddsType={oddsType}
            decimalPlaces={size && size === "small" ? 1 : 3}
          />
        )}
      </div>
    </div>
  );
};

export default AsianOddsPriceContainer;
